@if (hasGenericError) {
	<div class="w-full h-full flex flex-col items-center justify-center p-5 gap-4">
		@if (hasForbiddenError) {
			<app-forbidden />
		} @else {
			<div class="flex flex-col items-center justify-center gap-3">
				<img
					src="../../../../assets/img/onetag_logo_description.png"
					alt="OneTag Logo"
					class="w-[28rem] h-auto"
				/>
				<h1 class="font-bold text-error text-5xl">Report not found</h1>
				<div class="font-bold text-secondary">
					We are sorry, but the report you are looking for is not available.
				</div>
			</div>
		}

		<p-button
			label="Return to home page"
			routerLink="/"
		/>
	</div>
}
